/**
 * Created by Ricardo Sansores on 2017-06-24.
 * "Customer" service
 *
 * This consumes suppliers REST Api
 *
 *
 */
import request from './request';
import { serializeParams } from '../common/helpers';

export const get = (url = '', params = {}) => {
    return request().get(`${url}${serializeParams(params)}`)
        .then(response => {
            return response.data;
        })
        .catch(error => {
          //TODO Hay que hacer un buen manejo de errores. Por ahora simplemente regresamos test data pero se debe borrar y en caso de error en el webservice propagarlo a la vista de alguna forma para que se maneje posteriormente.
            return testData;
        });
};

export const post = (url = '', params = {}) => {
    return request().post(url, params)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            return error;
        });
};

export const put = (url = '', params = {}) => {
    return request().put(url, params)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            return error;
        });
};

export const Delete = (url = '', params = {}) => {
    return request().delete(url, params)
        .then(response => {
            return { message: "El Proveedor fue eliminado correctamente", color: '#04B404'};
        })
        .catch(error => {
            return { message: error.response.data.message, color: '#ce3b3b'};
        });
};

var testData = {
  "_embedded" : {
    "suppliers" : [ {
      "name" : "Aguascalientes",
      "taxId" : "adfsfd",
      "phone1" : "3314247302",
      "phone2" : null,
      "email1" : "rogelio@ssf.mx",
      "email2" : null,
      "email3" : null,
      "address" : {
        "street" : "Av. Castillo de Chapultepec",
        "externalNumber" : "2883",
        "internalNumber" : null,
        "zipCode" : "44066",
        "colony" : "El Fortin",
        "city" : "Zapopan",
        "state" : "Jalisco",
        "country" : 1,
        "municipality" : "Zapopan"
      },
      "_links" : {
        "self" : {
          "href" : "http://localhost:8080/afs/v1/suppliers/fd117b81-2b87-40fd-a9e8-b0e60a70b371"
        },
        "supplier" : {
          "href" : "http://localhost:8080/afs/v1/suppliers/fd117b81-2b87-40fd-a9e8-b0e60a70b371"
        },
        "executiveUser" : {
          "href" : "http://localhost:8080/afs/v1/suppliers/fd117b81-2b87-40fd-a9e8-b0e60a70b371/executiveUser"
        }
      }
    } ]
  },
  "_links" : {
    "self" : {
      "href" : "http://localhost:8080/afs/v1/suppliers{?page,size,sort}",
      "templated": true
    },
    "profile" : {
      "href" : "http://localhost:8080/afs/v1/profile/suppliers"
    },
    "search" : {
      "href" : "http://localhost:8080/fs/v1/suppliers/search"
    },
    "saveCustomerWithAddress" : {
      "href" : "http://localhost:8080/afs/v1/suppliers/full"
    }
  },
  "page" : {
    "size" : 20,
    "totalElements" : 1,
    "totalPages" : 1,
    "number" : 0
  }
}



// WEBPACK FOOTER //
// ./services/suppliers.js